<template>
  <div class="flex_row_center">
    <div class="main" style="margin-top: 50px; width: 80%">
      <div class="swiper" @mouseover="mySwiperStop" @mouseout="mySwiperStart">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in pic" :key="index">
            <div class="flex_column_center" >
              <viewer>
              <img :src="item.url" alt="" class="swiper-slide-img" />
            </viewer>
              <div style="margin-top: 10px; font-size: 14px">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
var global = require("@/utils/global");
export default {
  name: "certificate",
  components: {},
  data() {
    return {
      mySwiper: undefined,
      pic: [
        {
          name: "初级职称样本",
          url: global.pictureBaseUrl + "/certificate/1、初级职称样本.png",
        },
        {
          name: "初级职称样本",
          url: global.pictureBaseUrl + "/certificate/2、初级职称样本.png",
        },
        {
          name: "初级职称样本",
          url: global.pictureBaseUrl + "/certificate/3、初级职称样本.jpg",
        },
        {
          name: "中级职称样本",
          url: global.pictureBaseUrl + "/certificate/4、中级职称样本.png",
        },
        {
          name: "中级职称样本",
          url: global.pictureBaseUrl + "/certificate/5、中级职称样本.png",
        },
        {
          name: "中级职称样本",
          url: global.pictureBaseUrl + "/certificate/6、中级职称样本.png",
        },

        {
          name: "高级职称样本",
          url: global.pictureBaseUrl + "/certificate/7、高级职称样本.png",
        },
        {
          name: "高级职称样本",
          url: global.pictureBaseUrl + "/certificate/8、高级职称样本.jpg",
        },
        {
          name: "高级职称样本",
          url: global.pictureBaseUrl + "/certificate/9、高级职称样本.jpg",
        },

        {
          name: "正高级职称样本",
          url: global.pictureBaseUrl + "/certificate/10、正高级职称样本.jpg",
        },
        {
          name: "正高级职称样本",
          url: global.pictureBaseUrl + "/certificate/11、正高级职称样本.jpg",
        },
        {
          name: "正高级职称样本",
          url: global.pictureBaseUrl + "/certificate/12、正高级职称样本.jpg",
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    initSwiper() {
      this.mySwiper = new Swiper(".swiper", {
        initialSlide: 5,
        spaceBetween: 30,
        slidesPerView: 3, // 一屏显示的slide个数
        observer: true,
        observerParents: true,
        autoplay: {
          delay: 500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 2000,
        loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
      });
    },
    mySwiperStart() {
      if (this.mySwiper) {
        this.mySwiper.autoplay.start();
      }
    },
    mySwiperStop() {
      if (this.mySwiper) {
        this.mySwiper.autoplay.stop();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiper {
  overflow: hidden;
}
/deep/.swiper-wrapper {
  -webkit-transition-timing-function: linear;
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
.swiper-slide-img {
  width: 280px;
}
@media screen and (max-width: 780px) {
  .swiper-slide-img {
  width: 80px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/public/certificate.vue